<template>
  <div>
    <vs-row>
      <vs-col>
        <vs-card class="cardx">
          <div slot="header" style="padding:10px;height: 100%;width:100%;display:flex;align-items: center;">
            <feather-icon @click="$router.go(-2)" icon="ArrowLeftIcon"  class="cursor-pointer navbar-fuzzy-search mr-4" />
            <h3>
              Trips report
            </h3>
          </div>
          <div>
            <vs-row>
              <vs-col vs-lg="8" vs-sm="8" vs-xs="8">
                <div class="mb-3" style="display:inline-block;vertical-align:middle;">
                  <vs-chip transparent color="success" class="mr-2">
                    {{title}}
                  </vs-chip>
                </div>
                <div class="mb-3" style="display:inline-block;vertical-align:middle;">
                  <vs-dropdown class="mr-2 mt-2"  vs-custom-content vs-trigger-click vs-drop-right :vs-dropdown-visible="true" >
                    <vs-chip transparent color="primary" style="min-width: 130px;">
                      <b>From</b>: {{since}}
                    </vs-chip>
                    <vs-dropdown-menu class="loginx">
                      <datepicker @input="updateDateQuery" calendar-class="border-none" :inline="true" v-model="dates.since" format="yyyy-MM-dd"></datepicker>
                    </vs-dropdown-menu>
                  </vs-dropdown>

                  <vs-dropdown class="mr-2 "  vs-custom-content vs-trigger-click vs-drop-right :vs-dropdown-visible="true" >
                    <vs-chip transparent color="primary" style="min-width: 130px;">
                      <b>To</b>: {{until}}
                    </vs-chip>
                    <vs-dropdown-menu class="loginx">
                      <datepicker @input="updateDateQuery" calendar-class="border-none" :inline="true" v-model="dates.until" format="yyyy-MM-dd"></datepicker>
                    </vs-dropdown-menu>
                  </vs-dropdown>
                </div>

              </vs-col>
              <vs-col vs-lg="4" vs-sm="4" vs-xs="4" style="vertical-align:middle;">
                <div style="text-align: right; vertical-align:middle;">
                  <vs-button class="mr-3 mb-3" @click="download" color="primary" type="filled">Download</vs-button>
                </div>
              </vs-col>
            </vs-row>


            <div  v-if="report">
              <vs-table
                stripe
                :data="report.trips">
                <template slot="thead">
                  <vs-th style="min-width: 120px;">
                    Date
                  </vs-th>
                  <vs-th>
                    Time
                  </vs-th>
                  <vs-th>
                    Route
                  </vs-th>
                  <vs-th>
                    Tag
                  </vs-th>
                  <vs-th>
                    Status
                  </vs-th>
                  <vs-th>
                    Available seats
                  </vs-th>
                  <vs-th>
                    Bookings
                  </vs-th>
                </template>
                <template slot-scope="{data}">
                  <vs-tr :key="'row'+index" v-for="(item,index) in data">
                    <vs-td >
                      {{item.date}}
                    </vs-td>
                    <vs-td>
                      {{item.hour_start}}
                    </vs-td>
                    <vs-td>
                      {{item.route}}
                    </vs-td>
                    <vs-td>
                      {{item.code}}
                    </vs-td>
                    <vs-td>
                      <vs-chip transparent :color="getChipColor(item.status)">
                        {{item.status}}
                      </vs-chip>
                    </vs-td>
                    <vs-td>
                      {{item.seats}}
                    </vs-td>
                    <vs-td>
                      {{item.bookings}}
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>

              <div class="mt-3 mb-3">
                <pagination :last-page="report.pagination.pages" v-model="page" />
              </div>
            </div>


          </div>
        </vs-card>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
  import {mapActions, mapState} from 'vuex';
  import moment from 'moment'
  import Datepicker from 'vuejs-datepicker';
  import { CalendarIcon } from 'vue-feather-icons'
  const FileDownload = require('js-file-download');

  export default {
    name: "Driver",
    components: {
      Datepicker,
      CalendarIcon
    },
    data(){
      return {
        filters: {},
        dates : {
          page: 0,
          since: moment().subtract(1,'weeks').toDate(),
          until: moment().toDate()
        },
        report : null,
        page: 0,
        drivers: [],
        title: '...',
        driver: null
      }
    },
    computed : {
      since(){
        return moment(this.dates.since).format('YYYY-MM-DD');
      },
      until(){
        return moment(this.dates.until).format('YYYY-MM-DD');
      },
      ...mapState(['partner_namespace']),
    },
    watch : {
      page(newVal, oldVal){
        if(newVal !== oldVal){
          this.onChangePage(newVal)
        }
      },
      filters : {
        deep: true,
        handler(newVal, oldVal){
          this.setRouteQuery();
          this.getItems()
        }
      },
      '$route.query': {
        deep: true,
        handler(newVal, oldVal){
          if(_.isEmpty(newVal)){
            //this.initData();
          }
        }
      }
    },
    created() {
      this.initData();
    },
    methods : {
      ...mapActions('partners',['fetchDriverTripsReport']),
      ...mapActions('drivers',['getDriver']),
      initData(){
        this.page = this.$route.query.page ? Number(this.$route.query.page) : 1;
        this.filters = {
          page:'1',
          limit: '20',
          since: this.since,
          until : this.until,
          ...this.$route.query
        };
        this.getDriver({id: this.$route.params.driver_id}).then(data=>{
          this.driver = _.cloneDeep(data);
          this.title = `${data.firstname} ${data.lastname}`
        });
        this.doSearch = _.debounce(this.getItems,300);
      },
      setRouteQuery(){
        let query = {...this.filters, page: `${this.page}`};
        if(!_.isEqual(query, this.$route.query)){
          try{
            this.$router.push({query: query});
          }catch(error){
          }
        }else{
        }
      },
      updateDateQuery(){
        this.page = 1;
        this.filters = {
          ...this.filters,
          page: '1',
          since: this.since,
          until : this.until,
        }
      },
      onChangePage(page){
        this.page = page;
        this.filters.page = `${page}`;
        //this.$router.push({query: {...this.$route.query, page}})
      },
      getItems(){
        this.$vs.loading({type:'point'});
        this.fetchDriverTripsReport({
          id: this.$route.params.driver_id,
          ...this.filters})
          .then(response=>{
            this.report = response.data;
            this.$vs.loading.close();
          })
          .catch(error=>{
            this.$vs.loading.close();
          })
      },
      download(){
        this.$vs.loading({type:'point'});
        this.fetchDriverTripsReport({
          id: this.$route.params.driver_id,
          since: this.since,
          until : this.until,
          export: true,
          format: 'csv'
        })
          .then(response=>{
            FileDownload(response.data, `driver-trips-report-${this.since}-${this.until}.csv`);
            this.$vs.loading.close();
          })
          .catch(error=>{
            this.$vs.loading.close();
          })
      },
      getChipColor(status){
        if(status === 'pending'){
          return 'warning';
        }else if(status === 'processing'){
          return 'danger';
        }else if(status === 'completed'){
          return 'success';
        }else{
          return 'success';
        }
      },
    }
  }
</script>

<style scoped>

</style>
